/** A food's picture on the web: the square thumbnail (or a camera to add one) and the large view. Shared by Food, the roundup card and Today. */
import { useEffect } from "react";
import type { FoodScope } from "../api.ts";
import { useFoodPhotoUrl } from "../lib/foodPhoto.ts";
import { useApi } from "../session.tsx";
import { Icon } from "./Icons.tsx";

/** A square picture of the food: the photo, or a camera to add one. Tap the picture to see it large. */
export function FoodThumb({ r, scope, local, onPhoto, onOpen }: { r: { id: string; name: string; photoId?: string }; scope: FoodScope; local?: string; onPhoto?(f: File): void; onOpen(url: string): void }) {
  const api = useApi();
  const url = useFoodPhotoUrl(api, scope, r.photoId, local);
  if (url) return <button type="button" className="food-thumb" aria-label={`Enlarge the photo of ${r.name}`} onClick={() => onOpen(url)}><img src={url} alt={`${r.name}`} width={64} height={64} loading="lazy" />{local && <span className="food-thumb-wait">Not sent yet</span>}</button>;
  if (!onPhoto) return null;
  return (
    <label className="food-thumb food-thumb-add" title="Add a photo">
      <Icon name="camera" size={22} />
      <span className="sr-only">Add a photo of {r.name}</span>
      <input type="file" accept="image/*" capture="environment" aria-label={`Add a photo of ${r.name}`} onChange={(e) => { const f = e.target.files?.[0]; e.target.value = ""; if (f) onPhoto(f); }} />
    </label>
  );
}

/** The picture large, over the screen. Tap anywhere, or Close, to go back. */
export function PhotoLarge({ url, name, onClose }: { url: string; name: string; onClose(): void }) {
  useEffect(() => { const k = (e: KeyboardEvent) => { if (e.key === "Escape") onClose(); }; window.addEventListener("keydown", k); return () => window.removeEventListener("keydown", k); }, [onClose]);
  return (
    <div className="food-photo-large" role="dialog" aria-modal="true" aria-label={`Photo of ${name}`} onClick={onClose}>
      <img src={url} alt={`Photo of ${name}`} />
      <button type="button" className="btn btn-big" onClick={onClose}>Close</button>
    </div>
  );
}

